export default __webpack_public_path__ + "static/media/img_16.9c40856a.jpg";